module.exports = __webpack_public_path__ + "static/media/squirrel.0166b7fe.svg";